import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { hasRole } from '../utils/rbac';

export default function RequireRole({ roles, children }) {
  let user = null;
  try { user = JSON.parse(localStorage.getItem('user')); } catch { user = null; }
  if (!user) return <Navigate to="/login" replace />;
  if (!hasRole(user, roles)) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>Access denied</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>You don't have permission to view this page.</Typography>
        <Button variant="contained" onClick={() => window.history.back()}>Go back</Button>
      </Box>
    );
  }
  return children;
}
